import React from 'react'
import { useTheme } from '@mui/material'
import useCustomStyles from '../../../utils/hooks/CustomStylesHook'

import PatientDetailsForm from './PatientDetailsForm'

const styles = () => ({
  patientDischargeFormContainer: {
    width: '100%',
    height: '100%',
    padding: '0.6% 3% 3% 3%',
    '& .MuiInputBase-input': {
      fontSize: '12px !important',
    },
    '& .MuiInputLabel-root': {
      fontSize: '12px !important',
    },
    '& .MuiSelect-select': {
      padding: '6px 8px',
    },
    '& .MuiFormControlLabel-label': {
      fontSize: '12px !important',
      fontWeight: 600,
    },
  },
})

const PatientDischargeSummary = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <div className={classes?.patientDischargeFormContainer}>
      <PatientDetailsForm />
    </div>
  )
}

export default PatientDischargeSummary
